import React, { useState } from 'react';
import './ManualAddBrand.css';

const ManualAddBrand = () => {
  const basePath = process.env.REACT_APP_API_URL || 'https://mars2.mediacle.net';
  const [domains, setDomains] = useState('');
  const [brandId, setBrandId] = useState('');
  const [brandUrl, setBrandUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResults(null);

    if (!domains.trim()) {
      setError('Please enter at least one domain');
      return;
    }

    if (!brandId.trim()) {
      setError('Please enter a brand ID');
      return;
    }

    if (!brandUrl.trim()) {
      setError('Please enter a brand URL');
      return;
    }

    // Parse comma-separated domains
    const domainList = domains
      .split(',')
      .map(d => d.trim())
      .filter(d => d.length > 0);

    if (domainList.length === 0) {
      setError('No valid domains found');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${basePath}/api/manual-adding/process`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          domains: domainList,
          brandId: brandId.trim(),
          brandUrl: brandUrl.trim()
        })
      });

      if (response.ok) {
        const data = await response.json();
        setResults(data);
      } else {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.message || errorData.error || `Server error: ${response.status}`;
        setError(errorMessage);
        console.error('API response not ok:', response.status, errorData);
      }
    } catch (err) {
      const errorMessage = err.message || 'Failed to process domains';
      setError(errorMessage);
      console.error('Error processing domains:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="manual-add-container">
      <h1>Manual Add Brand - SEMrush Data Processing</h1>

      <form onSubmit={handleSubmit} className="manual-add-form">
        <div className="form-group">
          <label htmlFor="brandId">Brand ID:</label>
          <input
            type="text"
            id="brandId"
            value={brandId}
            onChange={(e) => setBrandId(e.target.value)}
            placeholder="Enter brand ID"
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="brandUrl">Brand URL:</label>
          <input
            type="text"
            id="brandUrl"
            value={brandUrl}
            onChange={(e) => setBrandUrl(e.target.value)}
            placeholder="Enter brand URL (e.g., example.com)"
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="domains">Domains (comma-separated):</label>
          <textarea
            id="domains"
            value={domains}
            onChange={(e) => setDomains(e.target.value)}
            placeholder="Enter domains separated by commas (e.g., domain1.com, domain2.com, domain3.com)"
            rows={5}
            disabled={loading}
          />
          <small>Separate multiple domains with commas</small>
        </div>

        <button type="submit" disabled={loading} className="submit-btn">
          {loading ? 'Processing...' : 'Process Domains'}
        </button>
      </form>

      {error && (
        <div className="error-message">
          <strong>Error:</strong> {error}
        </div>
      )}

      {results && (
        <div className="results-container">
          <h2>Processing Results</h2>
          <div className="results-summary">
            <p><strong>Total Processed:</strong> {results.totalProcessed}</p>
            <p><strong>Successful:</strong> {results.successful}</p>
            <p><strong>Failed:</strong> {results.failed}</p>
          </div>

          {results.results && results.results.length > 0 && (
            <div className="domain-results">
              <h3>Domain Details:</h3>
              {results.results.map((result, index) => (
                <div key={index} className={`domain-result ${result.success ? 'success' : 'failure'}`}>
                  <h4>{result.domain}</h4>
                  <p><strong>Status:</strong> {result.success ? 'Success' : 'Failed'}</p>

                  {result.insertedCount !== undefined && (
                    <p><strong>Records Inserted:</strong> {result.insertedCount}</p>
                  )}

                  {result.logs && result.logs.length > 0 && (
                    <div className="logs">
                      <strong>Logs:</strong>
                      <ul>
                        {result.logs.map((log, logIndex) => (
                          <li key={logIndex}>{log}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {result.error && (
                    <p className="error-text"><strong>Error:</strong> {result.error}</p>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ManualAddBrand;
